var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1665 7.39552C1.16653 6.28272 1.53223 5.1961 2.21531 4.27918C2.8984 3.36226 3.86673 2.65818 4.99241 2.25992C6.1181 1.86166 7.34818 1.78796 8.52018 2.04856C9.69219 2.30916 10.751 2.8918 11.5568 3.71952C11.6135 3.77553 11.6821 3.82019 11.7583 3.85072C11.8346 3.88125 11.9168 3.897 11.9998 3.897C12.0829 3.897 12.1651 3.88125 12.2413 3.85072C12.3176 3.82019 12.3862 3.77553 12.4429 3.71952C13.2461 2.88642 14.3052 2.29889 15.4791 2.03512C16.653 1.77135 17.8861 1.84386 19.0143 2.243C20.1424 2.64214 21.1122 3.34897 21.7944 4.26942C22.4766 5.18987 22.8389 6.28028 22.8332 7.39552C22.8332 9.68552 21.2082 11.3955 19.5832 12.8955L13.6335 18.2085C13.4316 18.4225 13.1828 18.5944 12.9034 18.7128C12.624 18.8312 12.3205 18.8934 12.0132 18.8952C11.7058 18.897 11.4015 18.8384 11.1205 18.7232C10.8395 18.6081 10.5883 18.4391 10.3835 18.2275L4.4165 12.8955C2.7915 11.3955 1.1665 9.69552 1.1665 7.39552Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector-1.35a8f6f06afc0e599392b216259fa728.svg";
export { ForwardRef as ReactComponent };